import { Spin } from "antd";
import { Loader2 } from "lucide-react";
import type { LoadingProps } from "../../types";

export function Loading({
  size = "default",
  fullScreen = false,
  tip,
}: LoadingProps) {
  const antIcon = (
    <Loader2
      style={{
        fontSize: size === "small" ? 24 : size === "large" ? 48 : 36,
      }}
      className="animate-spin"
    />
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/80 z-50">
        <div className="text-center">
          <Spin indicator={antIcon} size={size} />
          {tip && <p className="mt-4 text-neutral-600">{tip}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-8">
      <div className="text-center">
        <Spin indicator={antIcon} size={size} />
        {tip && <p className="mt-4 text-neutral-600">{tip}</p>}
      </div>
    </div>
  );
}

export default Loading;
